export default {
  BASE_URL: 'content/aboutUs',
  api: [
    {
      name: 'categories',
      method: 'GET',
      desc: '获取关注分类',
      path: 'catalogList'
    },
    {
      name: 'updateCategorySortNum',
      method: 'POST',
      desc: '更新关注分类排序顺序',
      path: 'upCataSort',
      params: {
        ids: ''
      }
    },
    {
      name: 'list',
      method: 'GET',
      desc: '获取关注分类列表',
      path: 'list',
      params: {
        helpTitle: '', // 标题或发布人姓名
        helpCataId: '', // 分类id
        order: '', // 排序规则
        prop: '', // 排序字段
        pageNum: 1,
        pageSize: 25
      }
    },
    {
      name: 'addCategory',
      method: 'POST',
      desc: '新增关于我们分类',
      path: 'addCatalog',
      params: {
        cataName: '', // 类型名称
        cataStatus: 0 // 类型状态 0 未启用 1 启用 2 停用
      }
    },
    {
      name: 'updateCategory',
      method: 'POST',
      desc: '编辑关于我们分类',
      path: 'editCatalog',
      params: {
        cataName: '',
        cataStatus: '',
        id: '' // 分类id
      }
    },
    {
      name: 'updateCategoryStatus',
      method: 'POST',
      desc: '启用/停用关于我们分类',
      path: 'upCataStatus',
      params: {
        id: '',
        cataStatus: ''
      }
    },
    {
      name: 'deleteCategory',
      method: 'GET',
      desc: '删除关于我们分类',
      path: 'delCatalog',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'add',
      method: 'POST',
      desc: '新增关于我们',
      path: 'addInfo',
      params: {
        helpTitle: '',
        seoKeyword: '',
        helpCataId: '',
        isRelease: '',
        helpSummary: '',
        sortNum: '',
        helpContent: ''
      }
    },
    {
      name: 'edit',
      method: 'POST',
      desc: '编辑关于我们',
      path: 'editInfo',
      params: {
        id: '',
        helpTitle: '',
        seoKeyword: '',
        helpCataId: '',
        isRelease: '',
        helpSummary: '',
        sortNum: '',
        helpContent: ''
      }
    },
    {
      name: 'info',
      method: 'GET',
      desc: '关于我们详情',
      path: 'aboutUsInfo',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'getSortNum',
      method: 'GET',
      desc: '获取排序号',
      path: 'getSortNum',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'delete',
      method: 'GET',
      desc: '删除关于我们',
      path: 'delDetail',
      append: true,
      params: {
        id: ''
      }
    },
    {
      name: 'updateStatus',
      method: 'POST',
      desc: '更新是否发布状态',
      path: 'upRelease',
      params: {
        id: '',
        isRelease: ''
      }
    },
    {
      name: 'checkCategoryName',
      method: 'POST',
      desc: '检查分类名称是否重复',
      path: 'checkCataName',
      params: {
        id: '',
        cataName: ''
      }
    },
    {
      name: 'getCategoryById',
      method: 'POST',
      desc: '根据分类id获取分类信息',
      path: 'cataInfo',
      params: {
        id: ''
      }
    },
    {
      name: 'checkHelpName',
      method: 'POST',
      desc: '检查关于我们名称',
      path: 'checkHomeName',
      params: {
        id: '',
        helpTitle: ''
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/about.js